import ExpandMore from '@mui/icons-material/ExpandMore';
import HelpOutlined from '@mui/icons-material/HelpOutlined';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { FAQ_ITEMS } from '../faqConfig.ts';

export const OpenXAgentFaq = () => {
  const { t } = useTranslation();

  return (
    <Box>
      {FAQ_ITEMS.map(({ question, answer }) => (
        <Accordion
          key={question}
          disableGutters
          elevation={0}
          square
          sx={{
            border: 0,
            boxShadow: 'none',
            '&::before': { display: 'none' },
            '& .MuiAccordionSummary-expandIconWrapper': { display: 'none' },
            '& .Mui-expanded .MuiAccordionSummary-expandIconWrapper': { display: 'flex' },
          }}
        >
          <AccordionSummary expandIcon={<ExpandMore sx={{ color: 'primary.main' }} />} sx={{ px: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <HelpOutlined fontSize="small" sx={{ color: 'primary.main', flexShrink: 0 }} />
              <Typography variant="body2" sx={{ fontWeight: 'fontWeightMedium', color: 'primary.main' }}>
                {t(question)}
              </Typography>
            </Box>
          </AccordionSummary>
          <AccordionDetails sx={{ borderTop: 0, pl: '44px', pr: 2, py: 0.5 }}>
            <Typography variant="body2" color="text.primary">
              {t(answer)}
            </Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
};
